<script>
import { XIcon } from 'vue-feather-icons'
import { mapGetters } from 'vuex'
import _ from 'lodash'

import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import { eventBus } from '@/vcs/_shared/eventBus'

export default {
  extends: BaseModal,
  components: { XIcon, CpuWireframe },
  data: function () {
    return {
      selectedCpu: null
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp'
    })
  },
  mounted() {
    this.selectedCpu = this.cp.units.filter((cpu) => {
      return _.map(cpu.boxes, 'id').indexOf(this.data.boxId) != -1
    })[0]
    eventBus.$emit('refresh-token-via-websockets')
  },
  methods: {
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    x-icon(size="1.5x" @click="$killSession()")
  .modal-body
    .row
      .col-12.col-lg-9
        h1.page__header {{ $t('pickup.pickupCompleteModal.header') }}
        h3.page__description.mb-5 {{ $t('pickup.pickupCompleteModal.desc') }}
      .col-12.col-lg-3
        .cpu-thumbnails(v-if="cp && data.boxId && selectedCpu")
          cpu-wireframe(
            v-for="cpu in cp.units"
            :key="cpu.id"
            :cpu="cpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="80"
            :openedBoxId="data.boxId || ''"
            :isSelected="cpu.id == selectedCpu.id"
            :displayIcons="false"
          )
    .row
      .col-12
        .selected-cpu(v-if="cp && data.boxId && selectedCpu")
          cpu-wireframe(
            v-if="!!selectedCpu"
            :cpu="selectedCpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="260"
            :openedBoxId="data.boxId || ''"
            :isSelected="true"
            :displayIcons="false"
          )
</template>

<style lang="scss" scoped>
.cpu-thumbnails {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.selected-cpu {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
